import type { ChatMessage } from '../../types/chatMessage';

export function createPlatformChatWelcomeMessage(options: {
  sessionId: string;
  content: string;
  assistantName: string;
}): ChatMessage {
  return {
    id: `platform-chat-welcome:${options.sessionId}`,
    sessionId: options.sessionId,
    content: options.content,
    sentAt: new Date(0).toISOString(),
    author: {
      type: 'ai',
      name: options.assistantName,
    },
  };
}
